import React from 'react';
import Reorderable from '@dashboard/components/Reorderable';
import FieldItem from './FieldItem';
import { useFields } from '../FieldsContext';
import { useFieldEdit } from '../FieldEditContext';
import Button from '@dashboard/components/Button';

export default function FieldsList() {
  const { state: fields } = useFields();
  const { isAddingField, onReorderFields, onAddField, isReordering } = useFieldEdit();

  return (
    <div>
      {fields.length > 0 && (
        <div className="mb-8">
          <Reorderable.Wrapper>
            <Reorderable
              id="fields"
              onReorder={onReorderFields}
              items={fields}
              renderItem={({ item: field, dragHandleProps, isDragging }) => (
                <Reorderable.Item isDragging={isDragging}>
                  <FieldItem
                    field={field}
                    disabled={isReordering}
                    dragHandleProps={dragHandleProps}
                  />
                </Reorderable.Item>
              )}
            />
          </Reorderable.Wrapper>
        </div>
      )}

      <div className="flex">
        <Button
          disabled={isAddingField || isReordering}
          handleClick={onAddField}
          appearance="primary"
        >
          + Add field
        </Button>
      </div>
    </div>
  );
}
